export default "__VITE_ASSET__31a49920__"